import useOrgSettingStore from "@/store/useOrgSettingsStore";
import { useMemo } from "react";

const useGetPointsTier = (points: number | null) => {
  const { pointTiers } = useOrgSettingStore();
  const typeTier:
      | "PLATINUM"
      | "GOLD"
      | "SILVER"
      | "BRONZE"
      | "ORIGINAL"
      | "DIAMOND"
      | undefined = useMemo(() => {
      if (pointTiers?.platinum && points && points >= pointTiers.platinum)
        return "PLATINUM";
      if (pointTiers?.gold && points && points >= pointTiers.gold) return "GOLD";
      if (pointTiers?.silver && points && points >= pointTiers.silver)
        return "SILVER";
      if (
        pointTiers?.bronze != null &&
        points != null &&
        points >= pointTiers.bronze
      )
        return "BRONZE";
      return undefined;
    }, [pointTiers, points]);
  
    const borderStyle = useMemo(() => {
      const borderMap: Record<string, React.CSSProperties> = {
        BRONZE: {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "#FF7875",
        },
        SILVER: {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "#8C8C8C",
        },
        PLATINUM: {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "#1890FF",
        },
        GOLD: {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "#FADB14",
        },
        ORIGINAL: {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "#1890FF",
        },
        DIAMOND: {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "#1890FF",
        },
        default: {},
      };
  
      return borderMap[typeTier as never] || borderMap.default;
    }, [typeTier]);

    return {
      borderStyle,
      tier: typeTier
    }
}
 
export default useGetPointsTier;